<template>
    <div id="new-busi-form" :class="fullScreen ? 'full-screen' : ''">
        <div class="new-head">
            <div class="head-left">
                <img src="/images/articleHeadLogo.png" />
                <div class="head-title">
                    <div class="head-span">
                        <span class="moduleT">{{ moduleTitle }}</span>
                        <!-- <span>{{ title }}</span> -->
                        <span>{{ busiInfo }}</span>
                    </div>
                    <div class="formTapBtn">
                        <div v-for="(item, index) in openTabList" :key="index" class="tapItemBtn" :class="activeName === index + '' ? 'active' : ''" @click="handleTabsClick(index + '', item)">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="head-right">
                <el-button @click="close">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    <span v-pageBtn-lbl="'close'">关 闭</span>
                </el-button>
                <el-button v-show="canEdit === 1 && formType === 'update'" v-pageBtn-lbl="'cancel'" icon="el-icon-close" @click="edit(0)">取 消</el-button>
                <template v-if="topRightBtns.length > 0">
                    <el-button v-for="(item, index) in topRightBtns" :key="index" @click="btnClick(item)">
                        <svg-icon style="margin-right: 5px" :icon-class="item.btnIcon" />
                        {{ item.btnName }}
                    </el-button>
                </template>
                <template v-else>
                    <el-button v-show="canEdit === 1 && noEdit !== 'true'" type="primary" :disabled="btnDisabled" :loading="submitLoading" @click="submit(false)">
                        <svg-icon style="margin-right: 5px" icon-class="save" />
                        <span v-pageBtn-lbl="'save'">保 存</span>
                    </el-button>
                    <el-button v-show="canEdit === 0 && noEdit !== 'true'" v-pageBtn-lbl="'modify'" icon="el-icon-edit" type="primary" @click="edit(1)">修 改</el-button>
                </template>
            </div>
        </div>
        <steps v-if="steps && (busiInfo == '开标登记' || busiInfo == '结果登记')" ref="steps" :vo="vo" :arr="tbData" @stepsClick="stepsClick" />
        <div v-if="show" class="busi-box">
            <div v-if="!bodyShow && !showBtn" class="busi-content">
                <div class="title-info">{{ openTabList.length > 0 ? openTabList[activeName].name : busiInfo }}</div>
                <div class="busi-components">
                    <busiFormW v-if="!isComponentForm" ref="person" :class="listDataBorder ? 'has-border' : 'no-border'" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" />
                    <components is="busiComponent" v-if="activeName === '0' && isComponentForm" ref="person" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" style="margin-top: 30px" />
                    <busiInner v-if="activeName === '0'" ref="inner" style="margin-top: 30px" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" />
                    <components is="otherComponent" v-if="activeName === '0'" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" style="margin-top: 30px" />
                    <Attachment ref="bottomAttachments" :cur-t-n="{ tnCanEdit: canEdit }" :vo="vo" :attachments="bottomAttachments" :wf-attach-url="url" :show-download-link="true" />
                </div>
            </div>
            <div v-if="showBtn" class="btn-container">
                <el-button style="width: 200px; height: 50px; font-size: 20px; background-color: #66b1ff; color: #ffffff" @click="openBtnUrl">发起申请</el-button>
            </div>
            <div v-if="bodyShow" style="display: flex; border-top: 1px solid #e6e6e6">
                <div id="bodyfilebox" class="bodyfile-container" style="height: calc(100vh - 85px); width: calc(100% - 366px)">
                    <iframe v-if="bodyFileUrl" id="pdfHtml" width="100%" height="100%" frameborder="0" scrolling="yes" :src="bodyFileUrl" />
                    <div v-else style="text-align: center; padding-top: 200px">
                        <svg style="font-size: 60px" data-v-5d08e6e2="" data-v-68e68533="" aria-hidden="true" class="nofile svg-icon">
                            <use data-v-5d08e6e2="" xlink:href="#icon-word1" />
                        </svg>
                        <div data-v-68e68533="" style="padding-top: 20px; padding-bottom: 30px; font-size: 13px"><span v-text-lbl="'common.noAttach'">暂无附件</span></div>
                    </div>
                </div>
                <div style="width: 366px; background: #fff">
                    <BodyFile :vo="vo" :auto-save="true" :cur-t-n="{ tnCanEdit: canEdit }" :fl-bodyfile="bodyfile" :attachments="attachments" :wf-attach-url="url" :file-need-sign="0" accept=".doc,.pdf,.ofd,.docx,.tif,.tiff" :viewer="'pdfjs'" :water-mark="true" show-mode="sidebar" :body-file-title="$tx('ecwapp.Wflowform.BodyFile.fileBody', '文件正文')" />
                    <Attachment ref="attachments" :cur-t-n="{ tnCanEdit: canEdit }" :vo="vo" :fl-bodyfile="bodyfile" :attachments="attachments" online-file=".doc,.docx,.xls,.xlsx,.ppt,.pptx" :wf-attach-url="url" :viewer="'pdfjs'" :show-download-link="true" show-mode="sidebar" />
                </div>
            </div>
        </div>

        <!-- 通用弹框 -->
        <select-dialog />
        <!-- 个别模块需要打开表单 -->
        <!-- <Basicform
      v-if="showForm&&innerBusiFormForNewWindow"
      ref="basicform"
      :title="formTitle"
      :win-width="moduleInfoT.winWidth"
      :win-height="moduleInfoT.winHeight"
      :module-code="moduleInfoT.moduleCode"
      :toolbar-btns="busiformBtns"
      :on-basic-form-before-open="onBasicFormBeforeOpen"
      :on-basic-form-opened="onBasicFormOpened"
      :on-basic-form-before-submit="onBasicFormBeforeSubmit"
      :on-basic-form-submited="onBasicFormSubmited"
    >
      <template v-slot:default="slotProps">
        <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoT" />
      </template>
    </Basicform> -->
    </div>
</template>

<script>
import { fullScreen, listDataBorder } from '@/wapp/settings'
import steps from './steps.vue'
export default {
    components: {
        steps
    },
    props: {},
    data() {
        return {
            voId: '',
            moduleInfo: {},
            activeTabIndex: 1,
            vo: {},
            canEdit: 0,
            listDataBorder: listDataBorder,
            fileList: [],
            showForm: true,
            show: false,
            formType: '',
            title: '',
            formUrl: '',
            newId: '',
            moduleInfoT: {},
            noEdit: '',
            btnDisabled: false,
            submitLoading: false,
            busiInfo: '基础信息',
            row: {},
            loginUser: this.$store.getters.loginUser,
            busiformBtns: [],
            topRightBtns: [],
            formTitle: '',
            uploadFiles: [],
            formItem: {},
            addChangeUpdate: false,
            moduleTitle: sessionStorage.getItem('setSysMenuName'),
            activeName: '0',
            openTabList: [],
            defaultBtn: ['submit', 'edit'],
            innerBusiFormForNewWindow: true,
            frmFullScreen: 0, // 是否全屏（表单控制）
            fullScreen: fullScreen, // 是否全屏（全局控制）
            bodyShow: false,
            bodyFileUrl: '',
            attachments: [],
            bottomAttachments: [], //通用附件框
            bodyfile: null,
            url: '',
            isComponentForm: false,
            steps: 0, // 当前步骤
            showBtn: false,
            btnUrl: '',
            tbData: [],
            tbxmId: ''
        }
    },
    computed: {},
    watch: {
        frmFullScreen: {
            handler(val) {
                if (val) {
                    this.fullScreen = true
                }
            },
            immediate: true
        }
    },
    created() {
        this.$bus.on('addUploadFiles', this.addUploadFiles)
        this.$bus.on('innerBusiFormShow', this.innerBusiFormShow)
        this.moduleInfo = JSON.parse(this.$route.query.moduleInfo)
        this.steps = this.moduleInfo.steps || 0
        this.showBtn = false
        this.btnUrl = this.moduleInfo.btnUrl || ''
        this.tbData = this.moduleInfo.tbData || []
        this.tbxmId = this.moduleInfo.tbxmId || ''
        if (this.$route.query.rowdata) {
            this.row = JSON.parse(this.$route.query.rowdata)
        }
        this.title = this.$route.query.title
        this.noEdit = this.$route.query.noEdit
        this.busiInfo = this.$route.query.busiInfo
        document.title = this.busiInfo + ' ' + '-' + ' ' + this.loginUser.sysName
        this.topRightBtns = this.$route.query.topRightBtns ? JSON.parse(this.$route.query.topRightBtns) : []
        window.addEventListener('beforeunload', (event) => {
            if (window.opener && window.opener.loadList) {
                window.opener.loadList()
            }
        })
        console.log('moduleInfo', this.moduleInfo)
        if (this.moduleInfo.listDataUrl) {
            const urlArr = this.moduleInfo.listDataUrl.split('/')

            this.url = urlArr[0] + '/' + urlArr[1]
        }

        if (this.$route.query.projectId) {
            this.tbxmId = this.$route.query.projectId
        }
    },
    beforeDestroy() {
        this.$bus.off('addUploadFiles', this.addUploadFiles)
        this.$bus.off('innerBusiFormShow', this.innerBusiFormShow)
        clearInterval(this.intervalId)
    },
    mounted() {
        this.vo = {}
        this.formUrl = this.$route.query.formUrl
        console.log('🚀 ~ mounted ~ this.formUrl:', this.formUrl)
        const workform = `#/dcontent/vuebusiform/W/${this.formUrl}.vue`
        console.log('🚀 ~ mounted ~ workform:', workform)
        if (this.formUrl && this.formUrl.indexOf('@/') > -1) {
            this.$options.components['busiComponent'] = this.$loadComponent(this.$route.query.formUrl)
            this.isComponentForm = true
        } else {
            this.$options.components['busiFormW'] = this.$loadComponent(workform)
            this.isComponentForm = false
        }

        if (this.$route.query.innerUrl && this.$route.query.innerUrl.indexOf('@/') > -1) {
            this.$options.components['otherComponent'] = this.$loadComponent(this.$route.query.innerUrl)
        } else if (this.$route.query.innerUrl) {
            const workform_inner = `#/dcontent/vuebusiform/W/${this.$route.query.innerUrl}.vue`
            this.$options.components['busiInner'] = this.$loadComponent(workform_inner)
        }
        if (this.$route.query.canEdit) {
            this.canEdit = this.$route.query.canEdit
        }
        if (this.$route.query.voId) {
            this.voId = this.$route.query.voId
            this.getVo(this.voId, this.moduleInfo)
            if (this.$route.query.editShow === '1') {
                this.canEdit = 1
            } else {
                this.canEdit = 0
            }
            this.formType = 'update'
        } else if (JSON.stringify(this.row) !== '{}') {
            this.vo = this.row
            this.canEdit = 0
            this.$nextTick(() => {
                this.show = true
            })
        } else {
            this.getVo(null, this.moduleInfo)
            this.canEdit = 1
            this.formType = 'addNew'
        }
        this.moduleInfo.formType = this.formType
        this.getStepsStatus()
        this.insertBrowsingHistory()
        // setTimeout(() => {
        //     if (document.querySelector('.el-table-toolbar .el-row .el-table-toolbar-right')) {
        //         document.querySelector('.el-tabs__header').style.margin = '0 0 -38px'
        //     }
        // }, 500)
        this.intervalId = setInterval(this.applyTabsHeaderStyle, 100)
    },
    methods: {
        getStepsStatus() {
            if (!this.tbxmId && this.vo.projectId) {
                this.tbxmId = this.vo.projectId
            }

            if (window.location.href.indexOf('tbxmlx') == -1) {
                this.$app.listdata('/tbgl/tbxmlx/listdata', { urlsearch: `id:${this.tbxmId}` }).then((res) => {
                    if (res.code === 'success') {
                        if (res.body.pageInfo.list.length > 0) {
                            this.tbData[0] = res.body.pageInfo.list[0]
                        }
                    }
                })
            }
            const param = {
                urlsearch: `projectId:${this.tbxmId}`
            }
            this.$app.listdata('/tbgl/tbbzjsq/listdata', param).then((res) => {
                if (res.code === 'success') {
                    if (res.body.pageInfo.list.length > 0) {
                        this.tbData[1] = res.body.pageInfo.list[0]
                    }
                    this.$app.listdata('/tbgl/bszzf/listdata', param).then((res) => {
                        if (res.code === 'success') {
                            if (res.body.pageInfo.list.length > 0) {
                                this.tbData[2] = res.body.pageInfo.list[0]
                            }
                        }
                        this.$app.listdata('/tbgl/kbdj/listdata', param).then((res) => {
                            if (res.code === 'success') {
                                if (res.body.pageInfo.list.length > 0) {
                                    this.tbData[3] = res.body.pageInfo.list[0]
                                }
                            }
                            this.$app.listdata('/tbgl/jgdj/listdata', param).then((res) => {
                                if (res.code === 'success') {
                                    if (res.body.pageInfo.list.length > 0) {
                                        this.tbData[4] = res.body.pageInfo.list[0]
                                    }
                                }
                                this.$app.listdata('/tbgl/zbfwfsq/listdata', param).then((res) => {
                                    if (res.code === 'success') {
                                        if (res.body.pageInfo.list.length > 0) {
                                            this.tbData[5] = res.body.pageInfo.list[0]
                                        }
                                    }
                                    if (this.$refs['steps']) this.$refs['steps'].setStepOptions(this.tbData)
                                })
                            })
                        })
                    })
                }
            })
        },
        stepsClick(index) {
            console.log('stepsClick', index)
            if (index > 0 && index < 6) {
                if (this.vo.projectId) {
                    this.tbxmId = this.vo.projectId
                } else if (this.$refs['steps'].active == 0) {
                    this.tbxmId = this.vo.id
                }

                if (this.tbData[index]) {
                    if (index == 1) {
                        console.log(this.vo)
                        this.btnUrl = `#/wflow?wfEngineUrl=tbgl%2Ftbbzjsq&busiDataId=${this.tbData[1].id}&orgCode=zdyr&listpageId=50d949a5207c4e9b9e1b22bd62d5c211&steps=${index}&tbxmId=${this.vo.id}`
                        // 替换现在的url，刷新浏览器
                        window.location.href = this.btnUrl
                        // 刷新当前页面
                        window.location.reload()
                    } else if (index == 2) {
                        console.log(this.vo)
                        this.btnUrl = `#/wflow?wfEngineUrl=tbgl%2Fbszzf&busiDataId=${this.tbData[2].id}&orgCode=zdyr&listpageId=50d949a5207c4e9b9e1b22bd62d5c211&steps=${index}&tbxmId=${this.tbxmId}`
                        // 替换现在的url，刷新浏览器
                        window.location.href = this.btnUrl
                        // 刷新当前页面
                        window.location.reload()
                    } else if (index == 3) {
                        let moduleInfo = {
                            formTemplate: 'dcontent/busiformurl?vwtype=W&url=/tbgl/kbdj/form.html',
                            addNewUrl: 'tbgl/kbdj/addNew',
                            insertUrl: 'tbgl/kbdj/insert',
                            getByIdUrl: 'tbgl/kbdj/getById',
                            updateUrl: 'tbgl/kbdj/update',
                            delUrl: 'tbgl/kbdj/delete',
                            listDataUrl: 'tbgl/kbdj/listdata',
                            winWidth: 1000,
                            winHeight: 600,
                            moduleCode: 'kbdj',
                            openViewType: '1',
                            listAdvSearchAllFields: 0,
                            listAdvSearchExpandPanel: 0,
                            busiFormTemplate: 'tbgl.kbdj.new_form',
                            listpageId: '61bccf6bf69149de943d0d1ca7a5c256',
                            steps: index,
                            showBtn: this.showBtn,
                            btnUrl: this.btnUrl,
                            tbData: this.tbData,
                            tbxmId: this.tbxmId
                        }
                        this.btnUrl = '#/newBusiForm?voId=' + this.tbData[3].id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('开标登记') + '&projectId=' + this.tbxmId + '&formUrl=tbgl.kbdj.new_form&noEdit=false&steps=' + index
                        // this.btnUrl = '#/newBusiForm?voId=' + this.tbData[2].id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('开标登记') + '&formUrl=tbgl.kbdj.new_form&noEdit=true'
                        // 替换现在的url，刷新浏览器
                        window.location.href = this.btnUrl
                        // 刷新当前页面
                        window.location.reload()
                    } else if (index == 4) {
                        let moduleInfo = {
                            formTemplate: 'dcontent/busiformurl?vwtype=W&url=/tbgl/jgdj/form.html',
                            addNewUrl: 'tbgl/jgdj/addNew',
                            insertUrl: 'tbgl/jgdj/insert',
                            getByIdUrl: 'tbgl/jgdj/getById',
                            updateUrl: 'tbgl/jgdj/update',
                            delUrl: 'tbgl/jgdj/delete',
                            listDataUrl: 'tbgl/jgdj/listdata',
                            winWidth: 1000,
                            winHeight: 600,
                            moduleCode: 'jgdj',
                            openViewType: '1',
                            busiFormTemplate: 'tbgl.jgdj.new_form',
                            listAdvSearchAllFields: 0,
                            listAdvSearchExpandPanel: 0,
                            listpageId: '752ec22c20e6494d91aeca5fd0ad4e20',
                            addNew: false,
                            steps: index,
                            showBtn: this.showBtn,
                            tbxmId: this.tbxmId
                        }
                        this.btnUrl = '#/newBusiForm?voId=' + this.tbData[4].id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('结果登记') + '&projectId=' + this.tbxmId + '&formUrl=tbgl.jgdj.new_form&innerUrl=&noEdit=false&editShow=0&sysCode=zdyr_ecyzhsp&steps=' + index
                        // 替换现在的url，刷新浏览器
                        window.location.href = this.btnUrl
                        // 刷新当前页面
                        window.location.reload()
                    } else if (index == 5) {
                        //    this.btnUrl = '#/wflow?wfEngineUrl=tbgl%2Fzbfwfsq&busiDataId=0385eb67d22448f690082bf051b1cf64&orgCode=zdyr&listpageId=098094fec39c456897333dc6abd51eb1'
                        this.btnUrl = `#/wflow?wfEngineUrl=tbgl%2Fzbfwfsq&busiDataId=${this.tbData[5].id}&orgCode=zdyr&listpageId=098094fec39c456897333dc6abd51eb1&steps=${index}&tbxmId=${this.tbxmId}`
                        // 替换现在的url，刷新浏览器
                        window.location.href = this.btnUrl
                        // 刷新当前页面
                        window.location.reload()
                    }
                } else {
                    this.showBtn = true
                    let id = this.tbxmId

                    if (index == 1) {
                        // window.open('#/wflow?wfEngineUrl=tbgl%2Ftbbzjsq&busiCode=tbbzjsq&wfName=投标保证金申请&startNodeName=', '_blank')
                        this.btnUrl = '#/wflow?wfEngineUrl=tbgl%2Ftbbzjsq&busiCode=tbbzjsq&wfName=投标保证金申请&startNodeName=&voId=' + id
                    } else if (index == 2) {
                        this.btnUrl = '#/wflow?wfEngineUrl=tbgl%2Fbszzf&busiCode=bszzf&wfName=标书制作费&startNodeName=&voId=' + id
                    } else if (index == 3) {
                        let moduleInfo = {
                            formTemplate: 'dcontent/busiformurl?vwtype=W&url=/tbgl/kbdj/form.html',
                            addNewUrl: 'tbgl/kbdj/addNew',
                            insertUrl: 'tbgl/kbdj/insert',
                            getByIdUrl: 'tbgl/kbdj/getById',
                            updateUrl: 'tbgl/kbdj/update',
                            delUrl: 'tbgl/kbdj/delete',
                            listDataUrl: 'tbgl/kbdj/listdata',
                            winWidth: 1000,
                            winHeight: 600,
                            moduleCode: 'kbdj',
                            openViewType: '1',
                            listAdvSearchAllFields: 0,
                            listAdvSearchExpandPanel: 0,
                            busiFormTemplate: 'tbgl.kbdj.new_form',
                            listpageId: '61bccf6bf69149de943d0d1ca7a5c256'
                        }
                        // window.open('#/newBusiForm?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('开标登记') + '&formUrl=tbgl.kbdj.new_form&noEdit=true')
                        this.btnUrl = '#/newBusiForm?voId=' + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('开标登记') + '&projectId=' + id + '&formUrl=tbgl.kbdj.new_form&noEdit=false'
                    } else if (index == 4) {
                        let moduleInfo = {
                            formTemplate: 'dcontent/busiformurl?vwtype=W&url=/tbgl/jgdj/form.html',
                            addNewUrl: 'tbgl/jgdj/addNew',
                            insertUrl: 'tbgl/jgdj/insert',
                            getByIdUrl: 'tbgl/jgdj/getById',
                            updateUrl: 'tbgl/jgdj/update',
                            delUrl: 'tbgl/jgdj/delete',
                            listDataUrl: 'tbgl/jgdj/listdata',
                            winWidth: 1000,
                            winHeight: 600,
                            moduleCode: 'jgdj',
                            openViewType: '1',
                            busiFormTemplate: 'tbgl.jgdj.new_form',
                            listAdvSearchAllFields: 0,
                            listAdvSearchExpandPanel: 0,
                            listpageId: '752ec22c20e6494d91aeca5fd0ad4e20',
                            addNew: false
                        }
                        this.btnUrl = '#/newBusiForm?voId=' + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('工作台') + '&busiInfo=' + encodeURIComponent('结果登记') + '&projectId=' + id + '&formUrl=tbgl.jgdj.new_form&innerUrl=&noEdit=false&editShow=0&sysCode=zdyr_ecyzhsp'
                    } else if (index == 5) {
                        this.btnUrl = '#/wflow?wfEngineUrl=tbgl%2Fzbfwfsq&busiCode=zbfwfsq&wfName=中标服务费申请&startNodeName=&voId=' + id
                    }
                }
            } else {
                if (window.location.href.indexOf('tbxmlx') == -1) {
                    this.btnUrl = `#/wflow?wfEngineUrl=tbgl%2Ftbxmlx&busiDataId=${this.tbxmId}&orgCode=zdyr&listpageId=21b0960a3b184bd099c8e571adc92c82&steps=${index}`
                    // 替换现在的url，刷新浏览器
                    window.location.href = this.btnUrl
                    // 刷新当前页面
                    window.location.reload()
                }
                this.showBtn = false
            }
        },
        openBtnUrl() {
            window.open(this.btnUrl, '_blank')
        },
        applyTabsHeaderStyle() {
            if (document.querySelector('.el-table-toolbar .el-row .el-table-toolbar-right')) {
                const tabsHeader = document.querySelector('.el-tabs__header')
                if (tabsHeader) {
                    // tabsHeader.style.margin = '0 0 -35px'
                }
            }
        },
        innerBusiFormShow(val) {
            this.innerBusiFormForNewWindow = val
        },
        handleTabsClick(val, item) {
            if (this.$refs.person.handleTabsClick) {
                new Promise((resolve, reject) => {
                    this.$refs.person.handleTabsClick(val, { resolve, reject })
                }).then((res) => {
                    this.activeName = val
                    this.$bus.emit('tabActive', val)
                })
            } else {
                this.activeName = val
                this.$bus.emit('tabActive', val)
            }
            if (item.name.indexOf('正文') > -1) {
                this.bodyShow = true
            } else {
                this.bodyShow = false
            }
        },
        addUploadFiles(formItem, fileList) {
            this.formItem = formItem
            this.uploadFiles = fileList
        },
        btnClick(btn) {
            if (typeof btn.btnClick === 'string') {
                if (!this.$refs.person[btn.btnClick] && this.defaultBtn.includes(btn.btnClick)) {
                    let query = ''
                    if (btn.btnType === 'edit') {
                        query = 1
                    } else {
                        query = false
                    }
                    btn.btnClick = this[btn.btnClick]
                    btn.btnClick(query)
                } else {
                    if (!this.$refs.person[btn.btnClick]) {
                        this.$alert(this.$tx('yoabase.alerts.formNotFun', '对应表单没有此方法'), this.$tx('common.operationTip', '操作提示'), {
                            confirmButtonText: this.$tx('yoabase.alerts.sure', '确定'),
                            type: 'warning'
                        })
                        return
                    }
                    btn.btnClick = this.$refs.person[btn.btnClick]
                    btn.btnClick.apply(this.$refs.person)
                }
            } else {
                if (btn.btnType === 'edit') {
                    btn.btnClick(1)
                } else if (btn.btnType === 'submit') {
                    btn.btnClick(false)
                } else {
                    btn.btnClick.apply(this.$refs.person)
                }
            }
        },
        reloadList() {
            if (this.formType === 'addNew') {
                location.href = location.href.replace('voId=', 'voId=' + this.newId)
            }
            this.formType = 'update'
            console.log(this.vo)

            setTimeout(() => {
                this.getVo(this.vo.id, this.moduleInfo)
            }, 1000)
        },
        submit(falg, callBack) {
            var _this = this
            console.log('this', this)

            this.$refs.person.formValidate(
                () => {
                    new Promise((resolve, reject) => {
                        _this.$refs.person.onBasicFormBeforeSubmit(_this, _this.vo, { resolve, reject })
                    })
                        .then((res) => {
                            _this.btnDisabled = true
                            _this.submitLoading = true
                            let serveiceUrl = ''
                            let serveiceMethod
                            if (!_this.addChangeUpdate) {
                                serveiceUrl = this.formType === 'addNew' ? this.moduleInfo.insertUrl : this.moduleInfo.updateUrl
                                serveiceMethod = this.formType === 'addNew' ? 'POST' : 'PUT'
                            } else {
                                serveiceUrl = this.moduleInfo.updateUrl
                                serveiceMethod = 'PUT'
                            }
                            new Promise((resolve, reject) => {
                                if (_this.$refs.person.$refs.attachments) {
                                    const uploadAttach = _this.$refs.person.$refs.attachments.uploadAttach
                                    let attachments = _this.$refs.person.$refs.attachments.attachments
                                    attachments = attachments.filter((item) => {
                                        return item.uploadTime === '待上传'
                                    })

                                    if (attachments.length > 0) {
                                        const array = []
                                        attachments.forEach((item) => {
                                            const fd = new FormData()

                                            fd.append('file', item.file.raw)
                                            fd.append('module', _this.moduleInfo.moduleCode)
                                            fd.append('attachsSize', item.file.size)
                                            fd.append('busiDataId', _this.vo.id)
                                            fd.append('attachsType', item.fileType)
                                            fd.append('attachsName', item.file.name)
                                            fd.append('uploadBy', _this.loginUser.personName)
                                            fd.append('uploadById', _this.loginUser.userId)
                                            array.push(
                                                this.$http({
                                                    method: 'POST',
                                                    url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                                                    data: fd
                                                })
                                            )
                                        })
                                        Promise.all(array).then((res) => {
                                            if (res.length === attachments.length) {
                                                resolve()
                                            }
                                        })
                                    } else {
                                        resolve()
                                    }
                                } else if (_this.bottomAttachments.length > 0) {
                                    const uploadAttach = _this.bottomAttachments
                                    console.log(uploadAttach)
                                    if (uploadAttach.length > 0) {
                                        const array = []
                                        uploadAttach.forEach((item) => {
                                            if (item.file) {
                                                const fd = new FormData()

                                                fd.append('file', item.file.raw)
                                                fd.append('module', _this.moduleInfo.moduleCode)
                                                fd.append('attachsSize', item.file.size)
                                                fd.append('busiDataId', _this.vo.id)
                                                fd.append('id', _this.vo.id)
                                                fd.append('attachsType', 'ATTACH')
                                                fd.append('attachsName', item.file.name)
                                                fd.append('uploadBy', _this.loginUser.personName)
                                                fd.append('uploadById', _this.loginUser.userId)
                                                array.push(
                                                    this.$http({
                                                        method: 'POST',
                                                        url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                                                        data: fd
                                                    })
                                                )
                                            }
                                        })
                                        Promise.all(array).then((res) => {
                                            if (res.length === uploadAttach.length) {
                                                resolve()
                                            }
                                        })
                                    } else {
                                        resolve()
                                    }
                                } else if (_this.attachments.length > 0) {
                                    const uploadAttach = _this.attachments
                                    if (uploadAttach.length > 0) {
                                        const array = []
                                        uploadAttach.forEach((item) => {
                                            const fd = new FormData()

                                            fd.append('file', item.file.raw)
                                            fd.append('id', _this.vo.id)
                                            fd.append('dataField', 'carPhoto')
                                            fd.append('nameField', 'fileName')
                                            array.push(
                                                this.$http({
                                                    method: 'PUT',
                                                    url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                                                    data: fd
                                                })
                                            )
                                        })
                                        Promise.all(array).then((res) => {
                                            if (res.length === uploadAttach.length) {
                                                resolve()
                                            }
                                        })
                                    } else {
                                        resolve()
                                    }
                                }
                                if (_this.uploadFiles.length > 0) {
                                    _this.uploadFiles.forEach((item) => {
                                        const uploadingFile = item
                                        const config = {
                                            onUploadProgress: (progressEvent) => {
                                                const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
                                                uploadingFile.progress = complete
                                                _this.$forceUpdate()
                                            }
                                        }
                                        let fieldUploadUrl = ''
                                        if (_this.formItem.downloadUrl !== undefined && _this.formItem.downloadUrl !== null && _this.formItem.downloadUrl !== '') {
                                            fieldUploadUrl = _this.formItem.downloadUrl.replace('/downloadById', '/upload').replace('/download', '/upload')
                                        }
                                        const nameField = this.formItem.nameField
                                        const dataField = this.formItem.propName
                                        this.$app.upload(fieldUploadUrl, item.raw, { id: _this.formItem.pid || this.vo.id, nameField: nameField, dataField: dataField }, config)
                                    })
                                    resolve()
                                } else {
                                    resolve()
                                }
                                setTimeout(() => {
                                    _this
                                        .$http({
                                            url: serveiceUrl,
                                            method: serveiceMethod,
                                            data: _this.vo
                                        })
                                        .then((res) => {
                                            _this.btnDisabled = false
                                            if (res.code === 'success') {
                                                _this.$message.success(res.message)
                                                if (!_this.addChangeUpdate) {
                                                    if (this.formType === 'addNew') {
                                                        _this.newId = res.body.vo.id
                                                        _this.moduleInfo.addNew = false
                                                        this.formType = 'update'
                                                    }
                                                }
                                                if (this.moduleInfo.moduleCode == 'jgdj') {
                                                    if (_this.vo.kbResult == 1) {
                                                        let xmvo = {
                                                            flSubject: _this.vo.tbXmmc,
                                                            tbXmbh: _this.vo.tbXmbh,
                                                            tbXmFzr: _this.vo.tbXmFzr,
                                                            projectCode: _this.vo.projectCode
                                                        }
                                                        let id
                                                        if (this.vo.projectId) {
                                                            id = this.vo.projectId
                                                        } else {
                                                            id = this.vo.id
                                                        }
                                                        window.open(`#/wflow?wfEngineUrl=tbgl%2Fzbfwfsq&busiCode=zbfwfsq&wfName=中标服务费申请&voId=${id}&startNodeName=&xmvo=${JSON.stringify(xmvo)}`)
                                                    }
                                                } else if (window.opener) {
                                                    const btnNewWflowform = window.opener.document.querySelector('#btnNewWflowform')
                                                    if (btnNewWflowform) {
                                                        opener.location.reload()
                                                    }
                                                }
                                            } else {
                                                _this.$message.error(res.message)
                                                _this.submitLoading = false
                                            }
                                        })
                                }, 100)
                            }).then((res) => {
                                console.log(res)

                                if (falg) {
                                    if (callBack) {
                                        callBack(true)
                                    }
                                    //  _this.$refs.person.onBasicFormSubmited(_this, () => {})
                                    _this.addChangeUpdate = true
                                    _this.submitLoading = false
                                    _this.reloadList()
                                } else {
                                    // _this.formType = 'update'
                                    _this.submitLoading = false
                                    _this.reloadList()
                                    // _this.$refs.person.onBasicFormSubmited(_this, _this.reloadList)
                                }
                            })
                        })
                        .catch((error) => {
                            this.$message.error(error)
                            _this.submitLoading = false
                        })
                },
                () => {
                    if (callBack) {
                        callBack(false)
                    }
                }
            )
        },
        close() {
            window.close()
        },
        edit(val) {
            this.show = false
            this.canEdit = val
            this.$nextTick(() => {
                this.show = true
                setTimeout(() => {
                    this.$bus.emit('tabActive', this.activeName)
                }, 0)
            })
            this.$forceUpdate()
        },
        insertBrowsingHistory() {
            const dataUrl = location.hash.substr(1)
            const params = {
                title: this.title,
                busiCode: this.moduleInfo.moduleCode,
                busiType: this.moduleTitle,
                busidataId: this.voId,
                dataUrl
            }
            this.$wappUtils.setBrowsingHistory(this, params)
        },
        getVo(id, moduleInfo) {
            if (id) {
                if (this.moduleTitle === '督查督办') {
                    this.$http({
                        method: 'get',
                        url: moduleInfo.getByIdUrl,
                        params: {
                            id: id,
                            taskUndertakeId: this.$route.query.taskUndertakeId
                        }
                    }).then((res) => {
                        console.log(res)

                        if (res.code === 'success') {
                            this.vo = res.body.vo
                        }
                        this.show = true
                    })
                } else {
                    this.$http({
                        method: 'get',
                        url: moduleInfo.getByIdUrl,
                        params: {
                            id: id
                        }
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.vo = res.body.vo
                            if (this.vo.passenger && this.vo.passenger.attachments && this.vo.passenger.attachments.length > 0) {
                                this.vo.passenger.attachments.forEach((attach) => {
                                    if (attach.fileType === 'BODY' && attach.fileName.indexOf('.pdf') > -1) {
                                        this.bodyfile = attach
                                        let fileurl = process.env.VUE_APP_BASE_API + `/${this.url}/downloadById?inline=true&attachIds=${attach.id}` + '&widthType=auto&viewType=mobile'
                                        fileurl += '&httpPort=' + location.port + '&fileName=' + attach.fileName + '&topdf=true'
                                        this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl)
                                    }
                                })
                            }
                            this.attachments = this.vo.passenger.attachments || []
                            this.bottomAttachments = this.attachments
                            console.log(this.attachments)
                        }
                        this.show = true
                    })
                }
            } else {
                this.$http({
                    method: 'post',
                    url: moduleInfo.addNewUrl
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        this.show = true
                    }
                })
            }
        }
    }
}
</script>
<style scoped lang="scss">
.btn-container {
    height: calc(100vh - 70px);
    padding: 0px 20px;
    background: white;
    display: flex !important;
    justify-content: center;
    align-items: center;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px !important;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px;
    /*滚动条的背景区域的圆角*/
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px;
    /*滚动条的圆角*/
    background-color: #f2f5fb;
    /*滚动条的背景颜色*/
}

/deep/.el-form .el-table__body .tdlbl {
    background: #f2f5fb !important;
}

#new-busi-form {
    height: 100%;
    background: #f0f2f5;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-title {
                margin-left: 10px;
                margin-top: 10px;
                font-size: 14px;
                color: #999999;

                .moduleT {
                    margin-right: 13px;
                    position: relative;
                }

                .moduleT::after {
                    position: absolute;
                    content: '';
                    width: 1px;
                    height: 12px;
                    right: -8px;
                    top: 50%;
                    background: #999999;
                    transform: translateY(-50%);
                }

                .formTapBtn {
                    display: flex;
                    margin-top: 10px;
                    font-family: MicrosoftYaHei;
                    color: #000000;
                    font-size: 14px;

                    .tapItemBtn {
                        position: relative;
                        margin-right: 15px;
                    }

                    .active {
                        position: relative;
                        color: var(--subjectColor);
                        font-weight: bold;

                        &::after {
                            content: '';
                            position: absolute;
                            bottom: -14px;
                            left: 0px;
                            width: 100%;
                            height: 2px;
                            background: var(--subjectColor);
                        }
                    }

                    .tapItemBtn:hover {
                        cursor: pointer;
                        color: var(--subjectColor);
                    }
                }
            }
        }
    }

    .busi-box {
        height: calc(100% - 68px);
        overflow: scroll;

        // padding-top: 20px;
        .busi-content {
            // width: 1200px;
            width: calc(100% - 40px);
            padding-bottom: 20px;
            background: white;
            min-height: 100%;
            margin: 0px auto;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
            margin-top: 20px;

            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }

            .busi-components {
                padding: 0 100px;
            }
        }

        @media (max-width: 1600px) {
            .busi-content {
                width: calc(100% - 40px);
            }
        }

        @media (min-width: 2120px) {
            .busi-content {
                width: calc(100% - 40px);
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }

    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: transparent !important;
    }

    /deep/.el-form .el-table__body .tdlbl .required {
        position: absolute;
        left: 6px;
    }

    /deep/.el-table__cell.tdlbl {
        padding: 4px 6px 4px 15px !important;
    }

    /deep/.el-form .el-table__body .tdlbl {
        text-align: left;
    }

    /deep/.el-form .el-table__body td.tdw17 {
        // width: 15.6% ;
        width: 15.6%;
    }

    /deep/.el-form .el-table__body td.tdw33 {
        width: 34.4%;
    }

    /deep/.el-form .el-table__body td.tdw83 {
        width: 84.4%;
    }

    /deep/.el-form .el-table__body td.tdw13 {
        width: 10.4%;
    }

    /deep/.el-form .el-table__body td.tdw20 {
        width: 22.9%;
    }

    /deep/.el-form .el-table.el-table--border td {
        border-right-color: #999 !important;
        // border-left-color: #999 !important;
        border-bottom-color: #999 !important;
        // border-top-color: #999 !important;
    }

    /deep/.el-table--border .el-table__cell {
        border-right: 1px solid #999;
    }

    /deep/.el-form .el-table.el-table--border {
        border-color: #999;
    }

    /deep/.el-form .el-table::before {
        background-color: #999;
    }

    /deep/.el-table--border::after,
    .el-table--group::after,
    /deep/.el-table::before {
        background-color: #999;
    }

    /deep/.title-container {
        border-color: #fff !important;
    }

    /deep/.title-container .has-bottom {
        border: 1px solid #999;
        border-bottom: 0px;
    }

    /deep/.el-form .el-table::after {
        background-color: #999;
    }

    /deep/.el-table--border {
        border-color: #999;
    }

    /deep/.el-tabs .el-tabs__header {
        width: 60%;
        background-color: unset;
    }

    /deep/.el-tabs__nav-wrap::after {
        height: 0px;
    }

    /deep/.el-table td.el-table__cell,
    /deep/ .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid #999;
    }

    /deep/.toolbar-box .el-button {
        border: 1px solid #999;
    }

    /deep/.el-popover__reference-wrapper .el-button-group .toolbar-box {
        padding: 0 1px 0 0;
    }
}

#new-busi-form.full-screen {
    .busi-content {
        width: calc(100% - 40px);
        min-width: 1000px;

        .busi-components {
            width: calc(100% - 13%);
            margin: 0 auto;
            padding: 0;
        }
    }

    @media (min-width: 3840px) {
        .busi-content {
            width: 3200px;
        }
    }
}
</style>
